module.exports = __webpack_public_path__ + "img/underline-gray.6d13a375.svg";